<template>
  <div class="p_supply_module p_receipt_box">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                  <div class="flname">实发月</div>
                  <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="listQuery.StrActualDate" @change="dateChange"
                        type="month" clearable
                        placeholder="">
                    </el-date-picker>
                </div>
                <div class="screenInput">
                    <div class="flname">施工队编号</div>
                    <el-input v-model="listQuery.StrConstrteamCode" size="small" clearable></el-input>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <el-tabs v-model="activePageName" @tab-click="handleClick" class="s_tabs_box">
          <el-tab-pane v-if="checkPermission(['verifySummary_tab_summary'],permissionLists)" label="结算核对汇总表" name="third"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_actual'],permissionLists)" label="实发报表" name="first"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_confirm'],permissionLists)" label="确认收款人数据" name="four"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_history'],permissionLists)" label="历史记录" name="second"></el-tab-pane>
        </el-tabs>
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" style="margin-right:0;" v-if="!this.isNull(this.tableData)&&(checkPermission(['receiptConfirmation_export'],permissionLists))">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" border v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('组合内容')>-1 ? '220px' : item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('身份证')>-1?'150px':'110px'" align="center"
              :fixed="item.StrColumName == '实发月'||item.StrColumName == '施工队编号'">
                <template slot-scope="{row}">
                  <span>{{ row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
            <!-- <el-table-column align="center" label="操作" width="160px">
              <template slot-scope="{row}">
                  <el-button type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                  <el-button type="info" size="mini" plain @click="deleteHandle(row)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activePageName:'four',
        isEditInput:true,
        downVisible:false,
        btnLoading:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'确认收款人数据',
        activeName:'six',
        tableData: [],
        dateRangeVal:[],
        listQuery:{
            StrConstrteamCode:'',// 编号
            StrActualDate:'',// 实发月选择
            currpage:1,
            perpage:10
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_confirm_TeamPayee', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        produceVisible:false,
        exportQuery:{},
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        StrActualDate:'',
        // 按钮权限参数
        butQuery:{
          path:'/verifySummary',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
        // let lastDate = moment().subtract(1,'months').format("YYYY-MM")
        // this.listQuery.StrActualDate = lastDate
        this.calHeight();
        this.getButtonPower()
        // 表头
        this.getTableTitleLists()
    },
    methods: {
      checkPermission,
        // 获取按钮权限
        getButtonPower(){
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
              }else{
                this.permissionLists = []
              }
            }else{
              this.permissionLists = []
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 详情
        // dtlHandle(row){
        //   this.$router.push(
        //     { path: '/generatedRecords',query:{
        //       gdident: row.Gdident
        //     }
        //   });
        // },
        dateChange(val){
            if(this.isNull(val)){
                this.listQuery.StrActualDate = ''
            }
        },
        // 子组件传值
        async currChange(value) {
            //   this.$store.commit("setSupComTabsIsover", false);
            // console.log('currChange',value)
            this.activeName = value
            if(this.activeName == 'first'){
                this.pageCrumb = '施工队列表'
            }else if(this.activeName == 'second'){
                this.pageCrumb = '施工队员列表'
            }else if(this.activeName == 'third'){
                this.pageCrumb = '费用单列表'
            }else if(this.activeName == 'four'){
                this.pageCrumb = '导入记录'
            }else if(this.activeName == 'five'){
                this.pageCrumb = '应收款报表'
            }else if(this.activeName == 'six'){
                this.pageCrumb = '实发报表'
            }
            //   this.getTableTitleLists()
        },
        handleClick(tab){
            if(tab.name == 'first'){
                this.$router.push({
                    path: '/generatedRecords',
                    query: {
                        active: 'first'
                    }
                })
            }
            if(tab.name == 'third'){
                this.$router.push({
                    path: '/verifySummary',
                    query: {
                        active: 'third'
                    }
                })
            }
            if(tab.name == 'second'){
                this.$router.push({
                    path: '/historyReport',
                    query: {
                        active: 'second'
                    }
                })
            }
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,this.titleQuery.strTableId).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getCostRecordsdetailLists(this.listQuery).then(res => {
            //   console.log('getList', res)
              if (res.status == 'ok') {
                    this.tableData = res.msg
                    this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
            this.listQuery = this.$options.data.call(this).listQuery
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.f_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_left{
    width: 60px;
    text-align: right;
    margin-right: 4px;
}
.add_form_item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.add_form_item .s_input{
    margin-right: 6px;
    width: 220px;
    text-align: center;
}
.dlt_icon{
    display: inline-block;
    font-size: 18px;
    color:#999;
    margin-left:20px;
    cursor: pointer;
}
.add_title_box{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 10px;
}
.t_item{
    width: 220px;
    text-align: center;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
  margin-bottom: 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_receipt_box .el-date-editor.el-input__inner{
    width: 260px!important;
}
.p_receipt_box .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border-color: #fff;
    text-align: center;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>